
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate",
      function () {
        return require("private-next-pages/real-estate/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate"])
      });
    }
  